export const PreQualifierAssetTypeSelectionErrorViewMessages = {
  errorMessage: {
    id: 'Pages.AssetTypeSelection.Page.errorMessage',
    description: 'Error Message when failed to fetch asset types',
  },
}
